// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-toolbar--mini-padding-top[data-v-467e6f10]{margin-top:1px}", ""]);
// Exports
module.exports = exports;
